// export default [
//     {label: 'Alternative', start: '#0c1957', end: '#282828'},
//     {label: 'Blues', start: '#00586c', end: '#282828'},
//     {label: 'Christian & Gospel', start: '#6e6746', end: '#282828'},
//     {label: 'Drum and Bass', start: '#6e6746', end: '#282828'},
//     {label: 'Classical', start: '#5d060b', end: '#282828'},
//     {label: 'Country', start: '#1b5220', end: '#282828'},
//     {label: 'Electronic', start: '#3c1b4b', end: '#282828'},
//     {label: 'Folk', start: '#4b2518', end: '#282828'},
//     {label: 'Hip-Hop/Rap', start: '#5d060b', end: '#282828'},
//     {label: 'Jazz', start: '#00586c', end: '#282828'},
//     {label: 'Latin', start: '#6e6746', end: '#282828'},
//     {label: 'Lounge/Chillout', start: '#3c1b4b', end: '#282828'},
//     {label: 'Metal', start: '#0c1957', end: '#282828'},
//     {label: 'Pop', start: '#ac2666', end: '#282828'},
//     {label: 'R&B/Soul', start: '#3c1b4b', end: '#282828'},
//     {label: 'Reggae', start: '#1b5220', end: '#282828'},
//     {label: 'Rock', start: '#00586c', end: '#282828'},
//     {label: 'Singer/Songwriter', start: '#ac2666', end: '#282828'},
//     {label: 'World/New Age', start: '#4b2518', end: '#282828'},
//     {label: 'Premium Podcast', start: '#6e6746', end: '#282828'},
// ] 

export default [
    {label: 'Alternative', start: '#6f2b8e', end: '#282828'},
    {label: 'Blues', start: '#6f2b8e', end: '#282828'},
    {label: 'Christian & Gospel', start: '#6f2b8e', end: '#282828'},
    {label: 'Drum and Bass', start: '#6f2b8e', end: '#282828'},
    {label: 'Classical', start: '#6f2b8e', end: '#282828'},
    {label: 'Country', start: '#6f2b8e', end: '#282828'},
    {label: 'Electronic', start: '#6f2b8e', end: '#282828'},
    {label: 'Folk', start: '#6f2b8e', end: '#282828'},
    {label: 'Hip-Hop/Rap', start: '#6f2b8e', end: '#282828'},
    {label: 'Jazz', start: '#6f2b8e', end: '#282828'},
    {label: 'Latin', start: '#6f2b8e', end: '#282828'},
    {label: 'Lounge/Chillout', start: '#6f2b8e', end: '#282828'},
    {label: 'Metal', start: '#6f2b8e', end: '#282828'},
    {label: 'Pop', start: '#6f2b8e', end: '#282828'},
    {label: 'R&B/Soul', start: '#6f2b8e', end: '#282828'},
    {label: 'Reggae', start: '#6f2b8e', end: '#282828'},
    {label: 'Rock', start: '#6f2b8e', end: '#282828'},
    {label: 'Singer/Songwriter', start: '#6f2b8e', end: '#282828'},
    {label: 'World/New Age', start: '#6f2b8e', end: '#282828'},
    {label: 'Premium Podcast', start: '#6f2b8e', end: '#282828'},
] 